import { defineGameCard, drawCards, onAppear } from '../authoring/index.js';
export const CampaignHeraldCard = defineGameCard({
    id: 'campaign_herald',
    gameplay: { type: 'UNIT', cost: 2, baseStats: { attack: 1, health: 2 } },
    presentation: {
        name: 'Глашатай похода',
        description: 'При раскрытии возьмите 1 карту.',
        glyph: {
            colors: ['#10213A', '#E99D48', '#410C19', '#8E371D', '#7B151F'],
            rows: [
                '.................1..',
                '.......11111....121.',
                '......1333331...1221',
                '.....133333331..1241',
                '.....13322221...1241',
                '......1322221...1441',
                '......1322221...141.',
                '.......14221...1531.',
                '.....11554251115531.',
                '....155252453335531.',
                '...1355525555535531.',
                '..1335355242533331..',
                '..135535524253331...',
                '..15553552425311....',
                '.13223355242531.....',
                '.13223355242531.....',
                '.13223355242531.....',
                '..1333355242531.....',
                '..1553355242531.....',
                '...11111111111......',
            ],
        },
    },
    role: 'playable',
    abilities: [onAppear(drawCards(1), { cause: 'played' })],
});
//# sourceMappingURL=campaign_herald.js.map